import { render, staticRenderFns } from "./SectionsUpdate.vue?vue&type=template&id=10b66a9c"
import script from "./SectionsUpdate.vue?vue&type=script&lang=js"
export * from "./SectionsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports